import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getRedirectPath } from '../utils/redirects';

/**
 * RedirectHandler Component
 * Handles FRONTEND-ONLY semantic URL redirects (old WordPress URLs → new React routes)
 * 
 * IMPORTANT: The following are handled by BACKEND MIDDLEWARE (server.py) to avoid redirect chains:
 * - Trailing slash normalization
 * - www → non-www
 * - HTTP → HTTPS
 * - /service/* → /services/*
 * - Spam URL blocking (410 GONE)
 * 
 * This component ONLY handles legacy URL redirects not covered by backend.
 */
const RedirectHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const path = location.pathname;
    
    // Check for legacy URL redirects (old WordPress URLs, etc.)
    const redirectPath = getRedirectPath(path);
    
    if (redirectPath) {
      // Use replace to avoid adding to browser history (acts like 301)
      navigate(redirectPath, { replace: true });
    }
  }, [location.pathname, location.search, navigate]);

  return null;
};

export default RedirectHandler;
